import { render, staticRenderFns } from "./articleEdit.vue?vue&type=template&id=6f073823&"
import script from "./articleEdit.vue?vue&type=script&lang=js&"
export * from "./articleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports